import { ThunkDispatch } from "redux-thunk";
import { RootState } from "../rootReducer";
import { SHOW_SNACK_BAR, SnackBarActionTypes } from "../snackBar/types";
import {
	OrderTypes,
	ORDER_READER,
	EMPTY_ORDER,
	EmptyOrderTypes,
	SAVE_PAYMENT_INTENT,
	PaymentIntentTypes,
	ORDER_READER_SUCCESS,
	ORDER_READER_FAIL,
	STRIPE_OR_POPID_ORDER
} from "./types";
import { methodsServices } from "../services/methodsService";
import { ENDPOINTS } from "../../utils/endpoints";
import { getErrorMessage, getPersonGender } from "../../utils/helpers";
import {
	KIOSK_MODES,
	LOCAL_STORAGE_DEEP_SIGHT,
	LOCAL_STORAGE_KIOSK_CHOICE_CONFIGURED,
	LOCAL_STORAGE_ORDER_ID,
	LOCAL_STORAGE_SELECTED_MODE,
	LOCAL_STORAGE_SELECTED_ORDER_TYPE
} from "../../utils/constants";
import {
	ShoopingCartModel,
	ShoopingProductModel
} from "../shoopingCart/models";
import { history } from "../../routes/history";
import { PATHS } from "../../routes/paths";
import { config } from "../../config/config";
import { PersonDTO } from "../deepSight/types";

/**
 * order for reader
 *
 * @returns
 */
export const passOrder = (cart: ShoopingCartModel, popIdStatus: number) => {
	return (
		dispatch: ThunkDispatch<
			RootState,
			undefined,
			OrderTypes | SnackBarActionTypes | EmptyOrderTypes
		>
	) => {
		dispatch({
			type: EMPTY_ORDER
		});
		dispatch({
			type: ORDER_READER
		});
		let formData = new FormData();
		cart.shoopingProduct.forEach(
			(shoopingProduct: ShoopingProductModel, index: number) => {
				formData.append(
					"products[" + index + "][id]",
					shoopingProduct.product.id.toString()
				);
				formData.append(
					"products[" + index + "][quantity]",
					shoopingProduct.quantity.toString()
				);
				formData.append("popid", popIdStatus);
				shoopingProduct.modifiersSelected.forEach(
					(modifier: number, modifierIndex: number) => {
						formData.append(
							"products[" +
								index +
								"][modifiers][" +
								modifierIndex +
								"]",
							modifier.toString()
						);
					}
				);
			}
		);

		const selectedMode =
			localStorage.getItem(LOCAL_STORAGE_SELECTED_MODE) || "";

		formData.append("kiosk_mode", selectedMode);
		formData.append(
			"mode_id",
			localStorage.getItem(LOCAL_STORAGE_KIOSK_CHOICE_CONFIGURED) || ""
		);
		formData.append("additional_notes", cart.comment);
		formData.append(
			"tip",
			Math.round(
				Number(Number(cart.tipToPay || 0).toFixed(2)) * 100
			).toString()
		);
		formData.append(
			"in",
			selectedMode === KIOSK_MODES.GLOBAL.toString()
				? localStorage.getItem(LOCAL_STORAGE_SELECTED_ORDER_TYPE) || ""
				: "1"
		);

		const detectedPerson: PersonDTO = JSON.parse(
			localStorage.getItem(LOCAL_STORAGE_DEEP_SIGHT) || "{}"
		);

		const age = detectedPerson?.age || null;
		const gender = detectedPerson?.gender
			? getPersonGender(detectedPerson.gender)
			: null;

		if (age) {
			formData.append("age", age.toString());
		}
		if (gender !== -1 && gender !== null) {
			formData.append("gender", gender.toString());
		}

		methodsServices
			.post(ENDPOINTS.ORDER, formData, true)
			.then((res: any) => {
				localStorage.setItem(
					LOCAL_STORAGE_ORDER_ID,
					res.data?.data?.order
				);
				dispatch({
					type: ORDER_READER_SUCCESS,
					payload: {
						clientSecret: res.data?.data?.client_secret,
						order: res.data?.data?.order,
						loading: false,
						paymentIntent: null
					}
				});
				if (!config.CARTE_ACTIVE) {
					history.push(PATHS.CHECKOUT);
				} else {
					popIdStatus === 0 && history.push(PATHS.PAYMENT);
				}
			})
			.catch((error: any) => {
				dispatch({
					type: SHOW_SNACK_BAR,
					payload: {
						message: getErrorMessage(error),
						severity: "error"
					}
				});
				dispatch({
					type: ORDER_READER_FAIL
				});
				history.push(PATHS.Home);
			});
	};
};

/**
 * empty reducer
 *
 * @returns
 */
export const emptyOrder = () => {
	return (dispatch: ThunkDispatch<RootState, undefined, EmptyOrderTypes>) => {
		dispatch({
			type: EMPTY_ORDER
		});
	};
};

/**
 * save payment intent
 *
 * @returns
 */
export const savePaymentIntent = (paymentIntent: any) => {
	return (
		dispatch: ThunkDispatch<RootState, undefined, PaymentIntentTypes>
	) => {
		dispatch({
			type: SAVE_PAYMENT_INTENT,
			payload: {
				paymentIntent: paymentIntent
			}
		});
	};
};

export const stripeOrPopId = (popid: number): PaymentTypes => ({
	type: STRIPE_OR_POPID_ORDER,
	popid: popid
});